import { render, staticRenderFns } from "./HowPage.vue?vue&type=template&id=1e08632f&"
import script from "./HowPage.vue?vue&type=script&lang=js&"
export * from "./HowPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports